import { GiftSubscriptionLandingPage, Pointers } from '../../types/GiftSubscriptionLandingPage'
import { absoluteImageUrl } from '../utils/environment'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fromStrapiGiftSubscriptionLandingPage = (strapiData: any): GiftSubscriptionLandingPage => {
    const { attributes: { description, senderBannerImage, redemptionLandingBanner, redemptionLandingDescription, termsAndConditions, faq, senderPointers, recipientPointers, senderPointerBannerImage, recipientPointerBannerImage } } = strapiData

    const bannerImageURL = absoluteImageUrl(senderBannerImage.data.attributes.url)

    const recipientLandingBannerImageURL = absoluteImageUrl(redemptionLandingBanner.data.attributes.url)

    const senderPointerBannerImageURL = absoluteImageUrl(senderPointerBannerImage.data.attributes.url)
    const recipientPointerBannerImageURL = absoluteImageUrl(recipientPointerBannerImage.data.attributes.url)

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mappedSenderPointers: Pointers[] = senderPointers.map((item: any) => ({
        title: item.title,
        description: item.description,
    }))

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mappedRecipientPointers: Pointers[] = recipientPointers.map((item: any) => ({
        title: item.title,
        description: item.description,
    }))

    return {
        description,
        bannerImageURL,
        recipientLandingBannerImageURL,
        recipientLandingDescription: redemptionLandingDescription,
        faq,
        senderPointerBannerImageURL,
        recipientPointerBannerImageURL,
        senderPointers: mappedSenderPointers,
        recipientPointers: mappedRecipientPointers,
        tnc: termsAndConditions,
    }
}

export { fromStrapiGiftSubscriptionLandingPage }